__turbopack_context__.v({
  "linkCard": "LinkCardGrid-module-scss-module__wOrDXa__linkCard",
  "linkCardButton": "LinkCardGrid-module-scss-module__wOrDXa__linkCardButton",
  "linkCardButtonIcon": "LinkCardGrid-module-scss-module__wOrDXa__linkCardButtonIcon",
  "linkCardContent": "LinkCardGrid-module-scss-module__wOrDXa__linkCardContent",
  "linkCardGridContainer": "LinkCardGrid-module-scss-module__wOrDXa__linkCardGridContainer",
  "linkCardImage": "LinkCardGrid-module-scss-module__wOrDXa__linkCardImage",
  "linkCardInner": "LinkCardGrid-module-scss-module__wOrDXa__linkCardInner",
  "linkCardSubText": "LinkCardGrid-module-scss-module__wOrDXa__linkCardSubText",
});
